import { PaginatedRequest } from '../requestModels/paginatedRequest';
import { PaginatedResult } from '../types/PaginatedResult';
import { Collection } from '../types/Collection';
import { TraceInfo } from '../types/TraceInfo';

import { GetCollectionDetailRequest } from '../requestModels/getCollectionDetailRequest';

import { httpGet } from './api.service';

const getCollections = async (request: PaginatedRequest): Promise<PaginatedResult<Collection>> => {
  return await httpGet<PaginatedResult<Collection>>(`api/collection`, request);
};

const getCollectionDetails = async (request: GetCollectionDetailRequest): Promise<PaginatedResult<TraceInfo>> => {
  const { collectionId, ...rest } = request;
  return await httpGet<PaginatedResult<TraceInfo>>(`api/collection/${collectionId}`, rest);
};

export { getCollections, getCollectionDetails };
